import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import classNames from 'classnames';
import { SIZE } from '../../../constants/general.js';
import { Icon } from '../Icon/Icon.js';
import styles from './index.module.scss.js';
import { LoadingIcon } from './LoadingIcon/index.js';
import { TEXT_ICON_STYLES, VARIANT, COLOR, BUTTON_SIZES, ICON_BUTTON, VARIANT_OPTION } from './constants/index.js';
import { checkButtonPropsCombinations } from './utils/index.js';
import { Text } from '../Text/index.js';
import { forwardRef } from '../../../utils/forwardRef.js';
import { SurfaceContrastMost, SurfaceMain } from '../../../../tokens/token-build/js/_semantic-colors-light.js';

const ButtonContent = ({ leftIcon, rightIcon, icon, text, isLoading, variant, size, }) => {
    if (isLoading) {
        // Todo: replace with themeLight with useTheme, not currently playing ball
        const [stroke, fill] = variant === VARIANT_OPTION.CONTAINED
            ? [SurfaceContrastMost, SurfaceMain]
            : [undefined, undefined];
        return (jsxs(Fragment, { children: [text && (jsxs(Fragment, { children: [leftIcon && (jsx(Icon, { icon: leftIcon, className: styles['button--hidden'] })), jsx(Text, { variant: size === SIZE.M ? 'buttonM' : 'buttonL', className: styles['button--hidden'], children: text }), rightIcon && (jsx(Icon, { icon: rightIcon, className: styles['button--hidden'] }))] })), icon && jsx(Icon, { icon: icon, className: styles['button--hidden'] }), jsx(LoadingIcon, { stroke: stroke, fill: fill, className: styles.button__spinner })] }));
    }
    if (icon) {
        return jsx(Icon, { icon: icon });
    }
    return (jsxs(Fragment, { children: [leftIcon && jsx(Icon, { icon: leftIcon }), jsx(Text, { variant: size === SIZE.M ? 'buttonM' : 'buttonL', children: text }), rightIcon && jsx(Icon, { icon: rightIcon })] }));
};
const Button = forwardRef(({ variant = 'contained', color, size = SIZE.M, leftIcon, rightIcon, as: Component = 'button', 
// TODO: Do not pass on className or style props
// eslint-disable-next-line no-restricted-syntax
className, text, icon, isLoading = false, disabled = false, 'aria-label': ariaLabel, ...props }, ref) => {
    checkButtonPropsCombinations({
        leftIcon,
        rightIcon,
        icon,
        text,
        ariaLabel,
    });
    const [leftIconStyle, rightIconStyle] = TEXT_ICON_STYLES[size];
    return (jsx(Component, { ...props, disabled: disabled || isLoading, "aria-label": text && isLoading ? ` ${text} loading` : ariaLabel, className: classNames(styles.button, VARIANT[variant], color && COLOR[variant][color], BUTTON_SIZES[size], leftIcon && leftIconStyle, rightIcon && rightIconStyle, icon && !isLoading && ICON_BUTTON[size], isLoading && icon && ICON_BUTTON[size], className), ref: ref, children: jsx(ButtonContent, { leftIcon, rightIcon, icon, text, isLoading, variant, size }) }));
});

export { Button };
